package dev.wyns.ventrova.data.model

/**
 * How many dishes (drinks excluded, desserts included) a place's menu has, and how many of them are
 * vegan or vegetarian. Dishes that are only vegan or vegetarian on request don't count.
 */
data class MenuStats(
    val foodItems: Int,
    val veganItems: Int,
    val vegetarianItems: Int,
)

/** Classification of a dish by the indexer's menu analysis. */
enum class MenuDiet(val databaseValue: String) {
    Vegan("vegan"),
    VeganOnRequest("vegan_option"),
    Vegetarian("vegetarian"),
    VegetarianOnRequest("vegetarian_option"),
    Meat("meat"),
    Unknown("unknown");

    companion object {
        fun fromDatabase(value: String?): MenuDiet = entries.firstOrNull { it.databaseValue == value } ?: Unknown
    }
}

data class MenuItem(
    val name: String,
    val description: String?,
    val section: String?,
    /** E.g. `main`, `dessert`; drinks are not included. */
    val course: String,
    val price: Double?,
    val diet: MenuDiet,
    /** True when the menu itself marks the dish (word or legend symbol), false when derived. */
    val labeled: Boolean,
    val confidence: Double?,
)
